// angular import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// project import
import { NavBarComponent } from './toolbar.component';
import { NavLeftComponent } from './toolbar-left/toolbar-left.component';
import { NavRightComponent } from './toolbar-right/toolbar-right.component';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { RenderAgoPipe } from '../../../pipes';
import { RouterLink } from '@angular/router';
import { DurationTextModule } from '@mri/app/modules';

@NgModule({
  declarations: [NavBarComponent, NavLeftComponent, NavRightComponent],
  imports: [CommonModule, SharedModule, RenderAgoPipe, RouterLink, DurationTextModule],
  exports: [NavBarComponent]
})
export class NavBarModule {}
